import React from 'react';

export const Instruction4 = () => {
  return (
    <div className="package-instruction__content">
      <p>
        <strong>PROBLEMS DURING TESTING</strong>
      </p>
      <p>
        <strong>You have 2 minutes to read this screen.</strong>
      </p>
      <p>
        <strong>These instructions explain what to do if you have a problem during testing.</strong>
      </p>

      <ul>
        <li>
          If you become&nbsp;<strong>ill</strong>, raise your hand to notify the invigilator. If you are not well enough
          to continue, ask to end your test. You then need to contact the UCAT Office as soon as possible.&nbsp;
          <strong>If you choose to continue testing, UCAT will not normally take any action</strong>.
        </li>
        <li>
          If you experience&nbsp;<strong>hardware/software problems, noise disturbance or other distractions</strong>,
          you must raise your hand&nbsp;<em>immediately</em>&nbsp;to inform the invigilator.&nbsp;
          <strong>If a problem is not reported during your test, UCAT will not normally take any action</strong>. The
          invigilator cannot answer questions about test content.
        </li>
        <li>If you find shortcut keys do not work, use your mouse to navigate through the test.</li>
        <li>If you experience a problem with the onscreen calculator, try these troubleshooting tips:</li>
        <li>Ensure that 'Num Lock&rsquo; is on for the number pad to work.</li>
        <li>
          Most calculator problems can be resolved by clicking the ON/C button or closing the calculator and
          relaunching.
        </li>
        <li>Use your mouse instead of the keyboard keypad to operate the calculator.</li>
      </ul>

      <p>
        Please click the&nbsp;<strong>Next (N)</strong>&nbsp;button to proceed before the time on this screen expires.
      </p>
    </div>
  );
};
